import React from 'react';
import styles from './AnswerCard.module.scss';

const AnswerCard = ({ index, showHints, onClick, gameId }) => {
    const content = showHints
        ? localStorage.getItem(`hint_${gameId}_${index}`) || ''
        : localStorage.getItem(`answer_${gameId}_${index}`) || '';

    const cardClass = showHints ? styles.cardHint : styles.cardAnswer;

    return (
        <div className={`${styles.card} ${content ? cardClass : styles.empty}`} onClick={onClick} >
            <p className={styles.numQuestion}>Énigme n° {index + 1}</p>
            <p>{content ? <span>{content}</span> : <span>?</span>}</p>
        </div>
    );
};

export default AnswerCard;
